import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Keep toasts clear of side safe areas (iPhone Duo's vertical status bar, landscape notch)
// on top of sonner's default 32px / 16px offsets. Sonner's mobile layout sizes the toast as
// 100% - 2 × left offset, so below 600px both sides take the larger inset to stay symmetric.
const SIDE = 'max(var(--sa-left), var(--sa-right))';
const BOTTOM = 'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))';
const OFFSET = {
  left: 'calc(32px + var(--sa-left))',
  right: 'calc(32px + var(--sa-right))',
  bottom: `calc(32px + ${BOTTOM})`,
};
const MOBILE_OFFSET = {
  left: `calc(16px + ${SIDE})`,
  right: `calc(16px + ${SIDE})`,
  bottom: `calc(16px + ${BOTTOM})`,
};

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      offset={OFFSET}
      mobileOffset={MOBILE_OFFSET}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
